import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";

export default function ResponsiveDialog({
	open,
	handleClose,
	title,
	subtitle,
	handleRejectRequest,
	REQUESTREJECTIONREASONS,
	checkedState,
	otherReason,
	setotherReason,
	handleOnChange,
	rejectLoading,
}) {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

	return (
		<div>
			<Dialog
				fullScreen={fullScreen}
				open={open}
				onClose={handleClose}
				aria-labelledby="responsive-dialog-title"
				sx={{
					borderRadius: "50px",
					"& .MuiDialog-paper": {
						borderRadius: "50px",
					},
				}}
			>
				<DialogTitle id="responsive-dialog-title">
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
						}}
					>
						<Typography
							variant="h6"
							component="div"
							sx={{ color: "primary.main", fontWeight: 700 }}
						>
							{title}
						</Typography>
						<Typography
							variant="h6"
							gutterBottom
							component="div"
							sx={{ color: "primary.main", fontWeight: 700 }}
						>
							{subtitle}
						</Typography>
					</Box>
				</DialogTitle>
				<DialogContent
					sx={{
						paddingLeft: "2rem",
						paddingRight: "2rem",
						textAlign: "center",
					}}
				>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							marginBottom: "2rem",
						}}
					>
						<Typography
							variant="body1"
							sx={{
								fontWeight: 700,
								color: "primary.main",
							}}
							gutterBottom
							component="div"
						>
							Do you want to reject this request?
						</Typography>
						<div>
							<p className="request_topic">Reason(s) For Rejection</p>
							<form onSubmit={handleRejectRequest}>
								<Box sx={{ mb: "1rem" }}>
									<FormGroup>
										{REQUESTREJECTIONREASONS.map((item, index) => (
											<FormControlLabel
												key={item}
												control={
													<Checkbox
														checked={checkedState[index]}
														onChange={() => handleOnChange(index)}
													/>
												}
												label={item}
											/>
										))}
									</FormGroup>
									{checkedState[checkedState.length - 1] && (
										<TextField
											id="other-reason-basic"
											label="Enter Other Reason"
											variant="outlined"
											multiline
											minRows={4}
											value={otherReason}
											onChange={(e) => setotherReason(e.target.value)}
											sx={{ width: "50ch" }}
										/>
									)}
								</Box>
							</form>
						</div>
						<Box
							sx={{
								display: "flex",
								justifyContent: "center",
								marginTop: "1rem",
							}}
						>
							<Stack direction="row" spacing={2} sx={{ alignSelf: "center" }}>
								<Button
									sx={{
										paddingLeft: "2rem",
										paddingRight: "2rem",
									}}
									variant="contained"
									onClick={() => handleRejectRequest()}
									disabled={rejectLoading}
									color="error"
								>
									{rejectLoading ? (
										<CircularProgress size="1.5rem" />
									) : (
										"Confirm Rejection"
									)}
								</Button>
								<Button
									sx={{
										paddingLeft: "3rem",
										paddingRight: "3rem",
									}}
									color="primary"
									variant="contained"
									onClick={() => {
										handleClose();
									}}
								>
									cancel
								</Button>
							</Stack>
						</Box>
					</Box>
				</DialogContent>
			</Dialog>
		</div>
	);
}
